import { useOrderContext } from "app/providers/OrderProvider";
import { usePaymentContext } from "pages/payment/providers/PaymentProvider";
import { useEffect, useMemo, useState } from "react";
import { WarrantyPackage } from "shared/api/middleware-api-client";
import PaymentWarrantyList from "features/payment-warranty-list";
import PaymentWarrantyText from "entities/payment-warranty-text";
import { concatClassnames } from "shared/utils/concatClassnames";
import { useWarrantyData } from "app/hooks";

interface WarrantyPackageProps {
  className?: string;
  page?: number;
  hideSelection?: boolean;
}

const PaymentWarranty: React.FC<WarrantyPackageProps> = ({
  className,
  hideSelection,
}) => {
  const { hasPaid } = usePaymentContext();
  const { order, getOrderWarrantyPackages } = useOrderContext();
  const { warrantyPackagesDataRequest } = useWarrantyData();
  const [warrantyPackageModalOpen, setWarrantyPackageModalOpen] =
    useState(false);
  const [selectedWarrantyPackageForModal, setSelectedWarrantyPackageForModal] =
    useState<WarrantyPackage>();
  const [showWarrantyChoice, setShowWarrantyChoice] = useState<boolean>(false);

  const orderWarrantyPackages = useMemo(
    () => getOrderWarrantyPackages(),
    [warrantyPackagesDataRequest],
  );

  useEffect(() => {
    toggleWarrantyChoice();
  }, [order?.warrantyPackage, hasPaid, orderWarrantyPackages]);

  const toggleWarrantyChoice = () => {
    if (!orderWarrantyPackages) return;

    if (
      (order?.warrantyPackage && !hasPaid) ||
      hideSelection ||
      order?.isSelfAssembly
    ) {
      setShowWarrantyChoice(false);
    } else {
      setShowWarrantyChoice(true);
    }
  };

  return (
    <div className={concatClassnames(className, "gg-mb-10")}>
      {showWarrantyChoice && (
        <>
          <PaymentWarrantyText />

          <PaymentWarrantyList
            isModalOpen={warrantyPackageModalOpen}
            setIsModalOpen={setWarrantyPackageModalOpen}
            setSelectedWarrantyPackageForModal={
              setSelectedWarrantyPackageForModal
            }
          />

          {/* <PaymentWarrantyModal
            isOpen={warrantyPackageModalOpen}
            setIsOpen={setWarrantyPackageModalOpen}
            warrantyPackage={selectedWarrantyPackageForModal}
          /> */}
        </>
      )}
    </div>
  );
};

export default PaymentWarranty;
